<script>
import AppSwitchToggle from "@/common-components/ui-elements/app-switch-toggle.vue";
import { useCampaignSettings } from "@/composables/campaign-settings";
import { defineComponent } from "vue";
import { mapState } from "vuex";

export default defineComponent({
  setup() {
    const { getSetting } = useCampaignSettings();

    return {
      getSetting,
    };
  },
  props: {},
  components: {
    AppSwitchToggle,
  },
  data() {
    return {
      metaData: {
        do_not_send_team_creation_email: {
          value: false,
        },
        do_not_send_new_linked_team_account_email: {
          value: false,
        },
      },
      metaDataServer: {},
      loading: false,
      firstLoading: true,
    };
  },
  computed: {
    ...mapState({
      cID: (state) => state.campaign.campaign.data.id,
      mode: (state) => state.campaign.campaign.data.attributes.mode,
    }),
    orgID() {
      return localStorage.getItem("orgId");
    },
  },
  mounted() {
    this.fetchMetaData().finally(() => {
      this.firstLoading = false;
    });
  },
  methods: {
    async fetchMetaData() {
      const promises = [];
      for (const key of Object.keys(this.metaData)) {
        promises.push(this.setMetaData(key));
      }
      this.loading = true;
      try {
        await Promise.allSettled(promises);
      } finally {
        this.loading = false;
      }
    },
    async setMetaData(key) {
      const setting = await this.getSetting(
        {
          cid: this.cID,
          oid: this.orgID,
          extraParams: {
            falback_to_meta_dir: 1,
          },
        },
        key
      );
      if (!setting) {
        return;
      }
      let data = null;
      if (
        Number(setting.id) === 0 &&
        Object.keys(setting.attributes.default_meta_value_off).length > 0
      ) {
        data = setting.attributes.default_meta_value_off;
      } else if (Object.keys(setting.attributes.meta_data).length > 0) {
        data = setting.attributes.meta_data;
      } else {
        data = { value: false };
      }
      this.metaData[key] = data;
      this.metaDataServer[key] = setting;
    },
    onInput(key, value, trueValue = true, falseValue = false) {
      this.metaData[key].value = value;
      this.$emit(`update:${key}`, value ? trueValue : falseValue);
    },
  },
});
</script>

<template>
  <div v-if="!firstLoading" class="d-flex flex-column">
    <AppSwitchToggle
      v-if="metaDataServer['do_not_send_team_creation_email']"
      :label="
        $t(
          'edit_campaign.email_template_toggle_do_not_send_team_creation_email_v2',
          'Send an email notification for new teams'
        )
      "
      :value="metaData.do_not_send_team_creation_email.value"
      @input="onInput('do_not_send_team_creation_email', $event, false, true)"
      :description="
        mode === 5
          ? $t(
              'edit_campaign.email_template_toggle_do_not_send_team_creation_email_v2_description',
              'This setting is not available for demo campaigns'
            )
          : null
      "
      :disabled="loading || mode === 5"
      :loading="loading"
      :true-value="false"
      :false-value="true"
      class="my-1"
    />
    <AppSwitchToggle
      v-if="metaDataServer['do_not_send_new_linked_team_account_email']"
      :label="
        $t(
          'edit_campaign.email_template_toggle_do_not_send_new_linked_team_account_email_v2',
          'Send Email for New Linked Team Account'
        )
      "
      :value="metaData.do_not_send_new_linked_team_account_email.value"
      @input="onInput('do_not_send_new_linked_team_account_email', $event, false, true)"
      :description="
        $t(
          'edit_campaign.email_template_toggle_do_not_send_new_linked_team_account_email_v2_description',
          'To send an email for new Linked Team Accounts, ensure that the account is marked as a Linked Team Account in the import file and that the default sub-account permissions are enabled.'
        )
      "
      :disabled="loading"
      :loading="loading"
      :true-value="false"
      :false-value="true"
      class="my-1"
    />
  </div>
  <div v-else class="d-flex flex-column">
    <b-skeleton class="my-1" type="button" />
    <b-skeleton class="my-1" type="button" />
  </div>
</template>
